export enum FulfillmentStatus {
  fulfilled = 'fulfilled',
  partial = 'partial',
  restocked = 'restocked',
  null = 'null',
}

interface IProductImage {
  src: string;
  alt: string;
  width: number;
  position: number;
}

export interface IOrderItem {
  title: string;
  price: number;
  variantId: string;
  productId: number;
  sku: string;
  vendor: string;
  grams: number;
  quantity: number;
  productImages: IProductImage[];
  product_type?: string;
}

export enum FinancialStatus {
  PAID = 'paid',
  AUTHORIZED = 'authorized',
  VOIDED = 'voided',
  REFUNDED = 'refunded',
  PARTIALLY_REFUNDED = 'partially_refunded',
  PARTIALLY_PAID = 'partially_paid',
  PENDING = 'pending',
  UNPAID = 'unpaid',
  ANY = 'any',
}

export enum OrderStatus {
  prepared = 'prepared',
  pending = 'pending',
  cancelled = 'cancelled',
}

export interface IFulfillment {
  trackingCompany: string | null;
  trackingUrl: string | null;
  trackingUrls: string[];
  trackingNumber: string | null;
  trackingNumbers: string[];
}

export interface INoteAttribute {
  name: string;
  value: string;
}

interface IOrderAddress {
  zip: string;
  country: string;
  city: string;
  address1: string;
  address2?: string;
  company?: string;
  name: string;
  phone: string;
}

interface IUpdatedTimeSlot {
  deliveryDate: string | null;
  endTime: string | null;
  startTime: string | null;
}

export interface IOrder {
  id: string;
  name: string;
  financialStatus: FinancialStatus;
  fulfillmentStatus: FulfillmentStatus;
  createdAt: string;
  cancelledAt?: string;
  totalPrice: number;
  noteAttributes: INoteAttribute[];
  lineItems: IOrderItem[];
  shippingAddress: IOrderAddress | null;
  fulfillments: IFulfillment[];
  sourceName?: string;
  parcelTrackingUrl: string;
  updatedTimeSlot: IUpdatedTimeSlot | null;
}

export interface IGetCustomerLastOrderQueryResult {
  getCustomerLastOrder: IOrder;
}

export enum WmsStatus {
  NEW = 'NEW',
  CREATED = 'CREATED',
  GENERATED = 'GENERATED',
  PICKING = 'PICKING',
  QUALITY_ANOMALY = 'QUALITY_ANOMALY',
  PACKING = 'PACKING',
  LABEL_PRINTED = 'LABEL_PRINTED',
  READY_TO_DISPATCH = 'READY_TO_DISPATCH',
  DISPATCHED = 'DISPATCHED',
  CANCELLED_IN_OMS = 'CANCELLED_IN_OMS',
  CANCELLED_IN_WMS = 'CANCELLED_IN_WMS',
}
